export default __webpack_public_path__ + "static/media/Weather.1653e10a.JPG";